<card class="traveller-wrapper hoverarea">

    <div class="card-header-content">

        <h1 *ngIf="(travellerList | keys).length === 1">
            {{Yii.t('wui-shared-js', 'Voyageur')}}
        </h1>
        <h1 *ngIf="(travellerList | keys).length > 1">
            {{(travellerList | keys).length}} {{Yii.t('wui-shared-js', 'Voyageurs')}}
        </h1>

        <btn label="APIS"
            type="actionMore"
            class="hovervisible"
            *ngIf="(travellerList | keys).length > 1 && (travellerList | keys).length !== hasNoApis.length"
            (click)="travellerDetails = !travellerDetails">
            <span class="icon">
                <fa-icon [icon]="travellerDetails ? iconEyeSlash : iconEye"></fa-icon>
            </span>
        </btn>


    </div>

    <div class="card-body-content">
        <list type="traveller"
              [list]="travellerList"
              [useApis]="useApis"
              [isHeader]="false"
              [m_viewDetailsFlag]="travellerDetails"
              [showErrors]="showErrors"
              [isError]="apisFlag">
        </list>
    </div>
</card>